<div
  class="g-menu flex w-[340px] flex-col gap-3 p-3"
  role="dialog"
  appFocusFirst
  (keydown.enter)="onEnter($event)"
  [attr.aria-label]="'features.data.filter_presets.template.apply_title' | translate">
  <header class="flex items-center gap-2">
    <span
      class="bg-accent-interactive text-accent-main inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-xs">
      <i [class]="ICONS.bracketsCurly"></i>
    </span>
    <span class="text-text-primary truncate text-[12.5px] font-semibold">{{
      preset().name
    }}</span>
  </header>

  @if (filterText()) {
    <app-dsl-text
      class="border-weak bg-surface block rounded-xs border px-2 py-1.5 text-[11.5px] break-words"
      [text]="filterText()" />
  }

  @if (!usable()) {
    <p class="form-help is-error">
      {{ 'features.data.filter_presets.template.unusable' | translate }}
    </p>
  }

  @for (field of inputs(); track field.name) {
    <div class="flex flex-col">
      <label class="form-label" [for]="inputId(field.name)">{{ field.label }}</label>
      <app-template-value-input
        [parameter]="field"
        [inputId]="inputId(field.name)"
        [label]="field.label"
        [value]="values()[field.name]"
        (valueChange)="setValue(field.name, $event)" />
    </div>
  }

  <div class="flex items-center justify-end gap-2">
    <button type="button" class="btn btn-cancel btn-sm" (click)="cancelled.emit()">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      type="button"
      data-testid="apply-template"
      class="btn btn-primary btn-sm disabled:cursor-not-allowed disabled:opacity-60"
      [disabled]="!canConfirm()"
      (click)="confirm()">
      {{ 'features.data.filter_presets.template.apply' | translate }}
    </button>
  </div>
</div>
